<template>
  <div class="digital-custome-container">
    <div class="pc d-none d-lg-block">
      <div class="container" data-aos="fade-left" :data-aos-duration="1 * 1000">
        <div class="left">
          <img src="~assets/img/solution/medical-equipment.png" alt="" />
        </div>
        <div class="right">
          <p class="intelligent-double-recording">医疗设备、仪器装备售后视频一码通</p>
          <p class="subtitle">
            疑难问题、障碍报修立“码”解决！ <br />设备档案一码认证，工程中心一码直连！ <br />工单0周转，效率高8倍！
          </p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
      </div>
    </div>
    <div class="d-lg-none mobile">
      <div class="container" data-aos="fade-left" :data-aos-duration="1 * 1000">
        <div class="top">
          <p class="title">医疗设备、仪器装备售后视频一码通</p>
          <p class="subtitle">
            疑难问题、障碍报修立“码”解决！ 设备档案一码认证，工程中心一码直连！ 工单0周转，效率高8倍！
          </p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
        <div class="bottom">
          <img src="~assets/img/solution/medical-equipment-mobile.png" alt="" />
        </div>
      </div>
    </div>
    <Form v-model="show" />
  </div>
</template>

<script>
  import Form from "@/components/Form/index.vue";
  export default {
    data() {
      return {
        show: false,
      };
    },
    components: {
      Form,
    },
    methods: {
      open() {
        if (typeof this.customBtnClick === "function") {
          this.customBtnClick.call();
        } else {
          this.show = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .pc {
    .container {
      display: flex;
      justify-content: space-between;
      padding: 58px 0 86px;
      .left {
        flex: 1;
        img {
          width: 500px;
          height: 336px;
        }
      }

      .right {
        flex: 1;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #363636;
        margin: 48px 0 0 131px;
        .intelligent-double-recording {
          font-size: 30px;
          font-weight: 500;
        }
        .subtitle {
          text-align: left;
          margin-top: 32px;
          font-size: 18px;
          font-weight: 400;
        }
        .btn-text {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #08c6ad;
          cursor: pointer;
          margin-top: 45px;
        }
      }
    }
  }
  .mobile {
    .container {
      padding: 40px 0 40px;
      .top {
        font-family: PingFangSC-Medium, PingFang SC;
        color: #363636;
        margin-left: 20px;
        .title {
          font-size: 18px;
          font-weight: 500;
        }
        .subtitle {
          font-size: 13px;
          font-weight: 400;
          padding: 18px 40px 0 0;
        }
        .btn-text {
          width: 102px;
          height: 24px;
          border-radius: 3px;
          border: 1px solid #0ab49e;
          margin-top: 16px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #08c6ad;
          text-align: center;
        }
      }
      .bottom {
        margin: 30px 20px 0 19px;
        img {
          width: 336px;
          height: 246px;
        }
      }
    }
  }
</style>
